import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoftwareSubscriptions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#c48cff",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5999 9.40003V3.33346C13.5999 3.08593 13.5016 2.84854 13.3265 2.67351C13.1515 2.49848 12.9141 2.40015 12.6666 2.40015H3.33341C3.08588 2.40015 2.84849 2.49848 2.67346 2.67351C2.49842 2.84854 2.40009 3.08593 2.40009 3.33346V9.40003H13.5999Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9196 12.2877C14.9827 12.4298 15.0094 12.5854 14.9971 12.7405C14.9848 12.8955 14.9339 13.0449 14.8492 13.1753C14.7644 13.3057 14.6485 13.4128 14.5118 13.487C14.3751 13.5611 14.2221 13.6 14.0666 13.6H1.93344C1.77794 13.6 1.6249 13.5611 1.48822 13.487C1.35154 13.4128 1.23556 13.3057 1.15081 13.1753C1.06606 13.0449 1.01522 12.8955 1.00292 12.7405C0.990625 12.5854 1.01725 12.4298 1.08038 12.2877L2.40009 9.40002H13.5999L14.9196 12.2877Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.06668 11.7333H8.93332",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSoftwareSubscriptions;
